
 <div class="dialog-content fullPanel">
	<h2>EWD Central Server - About</h2>
	<div class="container">
		<div class="col eight">
			<p title="EWD Api Version: {{ewdapi_version}}&#010;Transport Api Version: {{transportapi_version}}&#010;Email Api Version: {{emailapi_version}}">
			Version: {{version}}<br>
			<p>Date: {{today}}</p>
		</div>
		<div style="text-align: center">
			<a style="outline: none;" href="https://mtdata.com.au/">
				<img class="logo" src="assets/images/logo.png" alt="MTData" />
			</a>
		</div>
	</div>
</div> 

